import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="product-filter"
export default class extends Controller {
  static targets = ["distributorSelect", "warehouseSelect", "warehouseRow"]
  static values = { warehouses: Object }

  connect() {
    this.updateWarehouses()
  }

  distributorChanged() {
    this.warehouseSelectTarget.dataset.selected = ""
    this.updateWarehouses()
  }

  updateWarehouses() {
    const distributorId = this.distributorSelectTarget.value
    const warehouses = this.warehousesValue[distributorId] || []
    const select = this.warehouseSelectTarget
    const selectedId = String(select.dataset.selected || "")

    const choiceItems = [{ value: "", label: select.dataset.placeholder, selected: !selectedId }]
    warehouses.forEach(w => {
      choiceItems.push({ value: String(w.id), label: w.name, selected: String(w.id) === selectedId })
    })

    // select — <select class="select-choices">, обёрнутый choices_controller.js.
    // Пока он ещё не успел подключиться (гонка при первой отрисовке),
    // правим сам <select> напрямую — Choices прочитает его options при инициализации.
    if (select.choices) {
      select.choices.clearStore()
      select.choices.setChoices(choiceItems, "value", "label", true)
    } else {
      select.innerHTML = ""
      choiceItems.forEach(({ value, label, selected }) => {
        const option = new Option(label, value)
        option.selected = selected
        select.appendChild(option)
      })
    }

    const visible = distributorId !== "" && warehouses.length > 0
    this.warehouseRowTarget.classList.toggle("d-none", !visible)

    if (!visible) {
      select.value = ""
      select.choices?.setChoiceByValue("")
    }
  }
}
